import * as React from "react";
import { ReactComponent as ApproveTickIcon } from "src/images/approveTick.svg";
import {
  CheckboxBox,
  CheckboxBoxWrapper,
  CheckboxInput,
  CheckboxLabel,
  CheckboxWrapper,
} from "./Checkbox.components";

interface Props {
  label: string | JSX.Element;
  onChange?: (value: boolean) => void;
  errorMessage?: string;
  value: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  ({ label, onChange, errorMessage, value }, ref) => {

    const handleClick = () => {
      if (onChange) {
        onChange(!value);
      }
    };

    return (
      <CheckboxWrapper>
        <CheckboxBoxWrapper>
          <CheckboxInput ref={ref} type="checkbox" onClick={handleClick} />
          <CheckboxBox className={errorMessage ? "has-error" : ""}>
            {value && <ApproveTickIcon />}
          </CheckboxBox>
        </CheckboxBoxWrapper>
        <CheckboxLabel className={errorMessage ? "has-error" : ""}>
          {label}
        </CheckboxLabel>
      </CheckboxWrapper>
    );
  }
);

export default Checkbox;
